import { Injectable } from "@angular/core";
import { AccountService } from "app/shared/services/account.service";
import { BaseService } from "app/shared/services/base.service";
import { type Observable, timer } from "rxjs";
import { switchMap, takeWhile } from "rxjs/operators";

export type BackgroundTaskStatus = {
  status: string;
};

@Injectable({
  providedIn: "root",
})
export class BackgroundTaskService extends BaseService {
  constructor(private readonly accountService: AccountService) {
    super();
  }

  getStatus(taskId: string): Observable<BackgroundTaskStatus> {
    return this.http.get<BackgroundTaskStatus>(
      `${this.baseUrl}backgroundtasks/${taskId}/status`,
      {
        headers: {
          ...this.baseHeaders,
          Authorization: String(this.accountService.getToken()),
        },
      },
    );
  }

  pollStatusUntilComplete(
    taskId: string,
    pollingIntervalMs: number = 1000,
  ): Observable<BackgroundTaskStatus> {
    return timer(0, pollingIntervalMs).pipe(
      switchMap(() => this.getStatus(taskId)),
      takeWhile(({ status }) => status !== "completed", true),
    );
  }
}
